/**
 * Default post-login route for CRC Drivers shell.
 */
import { getDriversDefaultRouteName, isDriversRole } from '@/utils/driversRoles';
import { isSuperAdminRole } from '@/utils/systemRoles';

export function getDefaultAuthedRoute(user) {
  if (!user?.id) {
    return { name: 'login' };
  }

  const roles = user.roles || [];

  if (isDriversRole(roles)) {
    const routeName = getDriversDefaultRouteName(roles);
    if (routeName) {
      return { name: routeName };
    }
  }

  const permissions = user.permissions || [];
  const canDashboard = ['dashboard.view.global', 'dashboard.view.department'].some((code) =>
    permissions.includes(code)
  );

  if (canDashboard || isSuperAdminRole(roles)) {
    return { name: 'dashboard' };
  }

  return { name: 'dashboard' };
}
